// =====================================================
// BED — Neutralisation de la taille de police racine fluide, le temps du BED
// =====================================================
// `src/styles/global.css` pose `html { font-size: 0.8333vw }` : tout le CRM est
// dimensionné en `rem` par rapport à la maquette desktop de 1920 px. C'est un
// choix cohérent pour l'outil interne (le staff travaille sur grand écran),
// mais il rend la racine proportionnelle à la largeur de fenêtre :
//
//     1920 px -> 16 px de racine        (maquette)
//      1180 px ->  9,8 px               (petit portable)
//       390 px ->  3,25 px              (téléphone) — illisible
//
// Le BED est la SEULE page du CRM ouverte par des participants, en très grande
// majorité depuis un téléphone (brief : « les équipages rempliront au
// téléphone »). Elle doit donc se dimensionner comme une page web normale.
//
// On fixe la racine pendant la durée de vie du bulletin et on la restaure en
// sortant : aucune autre page du CRM n'est affectée, et on ne touche pas à la
// feuille de style globale (dont dépendent toutes les vues staff).

import { useEffect } from 'react';

/** Taille de racine de référence (celle que vise `0.8333vw` à 1920 px). */
export const BED_ROOT_FONT_SIZE = '16px';

export function useFixedRootFontSize(fontSize: string = BED_ROOT_FONT_SIZE): void {
  useEffect(() => {
    const root = document.documentElement;
    // Valeur inline précédente uniquement : on ne mémorise pas la valeur
    // calculée, pour restaurer la règle CSS d'origine et non un figement.
    const previous = root.style.fontSize;
    root.style.fontSize = fontSize;
    return () => {
      root.style.fontSize = previous;
    };
  }, [fontSize]);
}
